export const ptBROauth = {
  title: 'Autorizar acesso',
  subtitle: '{{clientName}} quer se conectar à sua conta Nomi',
  permissionsIntro: 'Este aplicativo poderá:',
  permLists: 'Ver e editar as listas da casa (adicionar, marcar e remover itens)',
  permFinance: 'Ver contas, despesas e resumos financeiros (somente leitura)',
  permAgenda: 'Ver os eventos da agenda da família (somente leitura)',
  actingAs: 'Conectado como {{name}}',
  approve: 'Autorizar',
  deny: 'Recusar',
  loading: 'Carregando…',
  invalidRequest: 'Solicitação de autorização inválida ou expirada.',
  submitError: 'Falha ao registrar sua decisão. Tente novamente.',
} as const;
